import colors from "../../base/colors";
import borders from "../../base/borders";
import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";
import { pickerMenuItemOverrides } from "../pickers";

const { text, action } = colors;
const { borderRadius } = borders;
const { size } = typography;

const menuItem = {
  styleOverrides: {
    root: ({ theme }: { theme: import("@mui/material/styles").Theme }) => ({
      minHeight: pxToRem(32),
      margin: `${pxToRem(1)} 0`,
      padding: `${pxToRem(5)} ${pxToRem(12)}`,
      borderRadius: borderRadius.sm,
      fontSize: size.sm,
      color: text.main,
      transition: "background-color 120ms ease, color 120ms ease",

      "&:hover, &:focus-visible": {
        backgroundColor: action.hover,
      },

      "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": {
        backgroundColor: action.selected,
        fontWeight: 600,
      },

      // Date/time picker digital clock — do not inherit dropdown minWidth
      ...pickerMenuItemOverrides(theme),
    }),
  },
};

export default menuItem;
